import { isType } from 'utils/typeguard';
import RpcMethod from './rpcMethod';
import { TRpcError, TRpcResult, TRpcSuccessResult } from './types';

const jsonrpc = '2.0';

export function getRpcParams<T extends object>(
  method: RpcMethod,
  params: T | null,
  id: string = '1'
): {
  jsonrpc: '2.0';
  id: string;
  method: RpcMethod;
  params: T | null;
} {
  return { jsonrpc, id, method, params };
}

export function throwIfRpcError<DataResult = unknown, DataError extends TRpcError = TRpcError>(
  rpcResult: TRpcResult<DataResult, DataError>
): TRpcResult<DataResult, DataError> {
  if (!isRpcResultSuccess(rpcResult)) {
    throw new Error(`RPC Error ${rpcResult.error?.code}: ${rpcResult.error?.message}`);
  }

  return rpcResult;
}

export function isRpcResultSuccess<DataResult = unknown, DataError extends TRpcError = TRpcError>(
  rpcResult: TRpcResult<DataResult, DataError>
): rpcResult is TRpcSuccessResult<DataResult> {
  return isType<TRpcSuccessResult<DataResult>>(rpcResult, 'result');
}
